import React from "react";
import { Save, X } from "lucide-react";

/** Shared header for every Settings sub-page. */
export const SettingsHeader = ({ kicker, title, description }) => (
  <div className="mb-8">
    <div className="text-[11px] uppercase tracking-[0.25em] text-zinc-500 mb-3 font-mono">
      Admin · Système · {kicker}
    </div>
    <h1 className="font-heading text-2xl md:text-4xl font-bold tracking-tight">{title}</h1>
    {description && <p className="text-zinc-500 mt-3 max-w-2xl">{description}</p>}
  </div>
);

/** Save bar with optional reset. */
export const SettingsSaveBar = ({ onSave, onReset, saving, testId = "settings-save", label = "Save all" }) => (
  <div className="flex items-center gap-2">
    <button
      data-testid={testId}
      onClick={onSave}
      disabled={saving}
      className="inline-flex items-center gap-2 px-5 h-10 bg-zinc-950 text-white text-sm rounded-md hover:bg-zinc-800 disabled:opacity-50"
    >
      <Save size={14} /> {saving ? "Saving…" : label}
    </button>
    {onReset && (
      <button onClick={onReset} className="inline-flex items-center gap-2 px-4 h-10 border border-zinc-200 text-sm rounded-md hover:bg-zinc-50">
        <X size={14} /> Reset
      </button>
    )}
  </div>
);

export const parseList = (raw) => {
  const arr = raw.split(/[,\s]+/).map((x) => parseInt(x, 10)).filter((n) => !Number.isNaN(n) && n > 0 && n <= 500);
  return Array.from(new Set(arr)).sort((a, b) => a - b);
};
